import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { FilterModel } from "../../../../../../domain/models/enum";

import FiscalNoteListPage from "../../../../../../presentation/pages/developer/issue/list";

import { settings } from "../../../../../configs/settings";


import generateFilter from "../../../../../../utils/generate-filter";
import { makeRemoteFiscalNoteNote } from "../../../../usecases/fiscal-note/remote-fiscal-note-factory";
import { FiscalNoteResponseModel } from "../../../../../../domain/models/fiscal-note";

function MakeInvoiceList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<FiscalNoteResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);

      const data = await makeRemoteFiscalNoteNote().load({
        size: settings.perPage,
        sort: "id,desc",
        page: params?.page,
        typeNoteFiscalEnum: "NORMAL",
        hasForeignService: false,
        query: params?.query,
        ...(params?.status && params?.status !== 0 ? { status: params.status } : {}),
        filters: generateFilter({
          ...params?.filters,
        }),
      });
      setList(data);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleReload();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <FiscalNoteListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
      isSuperAdmin={!!user?.roles?.find((r: any) => r.authority === "SUPERADMIN")}
    />
  );
}

export default MakeInvoiceList;
